/**
 * Store/retrieve the user's phone number locally.
 * The raw phone never leaves the device — only a SHA-256 hash is sent to the server.
 */

const PREFIX = 'rostfound_phone_';

export function saveLocalPhone(userId: string, phone: string): void {
  localStorage.setItem(`${PREFIX}${userId}`, phone);
}

export function getLocalPhone(userId: string): string | undefined {
  return localStorage.getItem(`${PREFIX}${userId}`) ?? undefined;
}

export function clearLocalPhone(userId: string): void {
  localStorage.removeItem(`${PREFIX}${userId}`);
}
